import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";

import RetinaImage from "./RetinaImage";
import styles from "./styles/Avatar.sass";

const cx = classNames.bind(styles);

class Avatar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      imageError: false,
    };
  }

  userInitials = (username, maxLength = 2) => (
    String(username)
      .split(/(?=[A-Z])|[\s.:\-_]+/)
      .slice(0, maxLength)
      .map(s => s[0])
      .join("")
      .toUpperCase()
  )

  render() {
    const { hover, className, username, ...props } = this.props;
    const { imageError } = this.state;

    let content;
    if (props.id) {
      content = <RetinaImage height={props.width} className={cx("avatarImage")} alt={username} onError={() => this.setState({ imageError: true })} {...props} />;
    }

    return (
      <div className={cx("avatar", className, { hasHover: hover })}>
        {props.id && !imageError ? (
          content
        ) : (
          <svg className={cx("avatarInitials")} xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 100 100">
            <text className={cx("avatarInitialsText")} fontSize="40" textAnchor="middle" x="50" y="50" dy="16.3">
              {this.userInitials(username)}
            </text>
          </svg>
        )
        }
        <div className={cx("avatarGradient")} />
      </div>
    );
  }
}

Avatar.propTypes = {
  hover: PropTypes.bool,
  id: PropTypes.string,
  width: PropTypes.number,
  username: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Avatar.defaultProps = {
  id: undefined,
  hover: false,
  width: undefined,
  className: undefined,
};

export default Avatar;
